<template>
  <section id="rutas">
    <div class="columns is-mobile header">
      <div class="column is-2 is-offset-8 has-text-right stops">
        <b-image
          :src="require('@/assets/images/ico-busstop-yellow.png')"
          alt="Bus stops number"
        ></b-image>
      </div>
      <div class="column is-2 has-text-right passengers">
        <b-image
          :src="require('@/assets/images/ico-buspassenger-blue.png')"
          alt="Bus passengers number"
        ></b-image>
      </div>
    </div>
    <div
      v-for="ruta in rutas"
      :key="ruta.idruta"
      :class="{
        columns: true,
        'is-mobile route': true
      }"
      @click="detalleRuta(ruta.trasladados)"
    >
      <div class="column is-3 has-text-left code">
        <b-image
          :src="require('@/assets/images/ico-route-sync-yellow.png')"
          alt="Ruta Activa"
          v-show="ruta.trasladados.id == $store.getters.rutactiva"
          style="display: block;left: -16px;width: 28px;float: left;top: -5px;margin-bottom: -32px"
        ></b-image>
        <h3 class="has-text-weight-bold is-size-1">{{ ruta.idruta }}</h3>
      </div>
      <div class="column is-5 is-narrow has-text-left name pt-5">
        <h4 class="has-text-weight-medium">
          {{ ruta.descripcion }}
        </h4>
        <p v-if="ruta.paradas.length > 0">
          {{ ruta.paradas[0].horaf }} -
          {{ ruta.paradas[ruta.paradas.length - 1].horaf }}<br />{{
            $moment
              .duration(
                $moment
                  .utc(ruta.paradas[ruta.paradas.length - 1].horaf, "HH:mm")
                  .diff($moment.utc(ruta.paradas[0].horaf, "HH:mm"))
              )
              .humanize()
          }}
        </p>
      </div>
      <div class="column is-2 has-text-right stops">
        <span
          class="circle stops is-size-2 has-text-weight-medium has-text-white"
          >{{ ruta.nparadas }}</span
        >
      </div>
      <div class="column is-2 has-text-right passengers">
        <span
          class="circle passengers is-size-2 has-text-weight-medium has-text-white"
          >{{ ruta.trasladados != 0 ? ruta.trasladados.ntrasladados : 0 }}</span
        >
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Rutas",
  components: {},

  data() {
    return {
      rutas: []
    };
  },

  mounted() {
    this.cargaRutas();
    this.$store.commit("SET_NAVBACK", { text: "Logout", url: "/logout" });
    console.log(this.varlogout);
  },
  methods: {
    cargaRutas() {
      if (this.$store.getters.routes.length == 0) {
        //2020-12-12/1 -> Para ver rutas de tarde
        this.axios.get("/api/listarutas").then(response => {
          this.$store.commit("SET_ROUTES", response.data.rutas);
          this.rutas = response.data.rutas;
          //console.log(this.rutas);
        });
      } else {
        this.rutas = this.$store.getters.routes;
      }
    },
    detalleRuta(tr) {
      if (
        this.$store.getters.rutactiva &&
        this.$store.getters.rutactiva != "null" &&
        this.$store.getters.rutactiva != tr.id
      ) {
        this.$buefy.dialog.confirm({
          title: "A V I S O - CAMBIO DE RUTA",
          message:
            "Tienes activa la ruta " +
            this.$store.getters.detalleruta.idruta +
            ", <br /><strong>¿seguro que deseas cambiar la ruta activa?</strong>",
          onConfirm: () => {
            if (tr != 0) {
              this.$router.push("/ruta-detalle/" + tr.id);
            } else {
              console.log("no hay traslados");
            }
          },
          type: "is-danger"
        });
      } else {
        if (tr != 0) {
          this.$router.push("/ruta-detalle/" + tr.id);
        } else {
          console.log("no hay traslados");
        }
      }
    },
    logout() {
      this.$auth
        .logout({
          url: "/api/logout",
          makeRequest: true,
          redirect: { name: "Login" }
        })
        .then(() => {
          this.$store.commit("SET_ISLOGGED", false);
        })
        .catch(e => {
          console.error(e);
        });
    }
  }
};
</script>
